import React, { ReactNode, Suspense } from 'react'

import { PageContainerSkeleton } from './PageContainerSkeleton'

type PageContainerProps = {
  children: ReactNode
}
export default function PageContainer({ children }: PageContainerProps) {
  return (
    <Suspense fallback={<PageContainerSkeleton />}>
      <div className="m-4">
        <div className="p-2">{children}</div>
      </div>
    </Suspense>
  )
}
